import { Directive, inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

/** Abstract snack bar component. */
@Directive()
export abstract class AbstractSnackBar<TData = void, TResult = void> {
	/** Snack bar ref. */
	protected readonly snackBarRef = inject<MatSnackBarRef<TResult>>(MatSnackBarRef);

	/** Snack bar data. */
	protected readonly snackBarData = inject<TData>(MAT_SNACK_BAR_DATA);
}
